import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { knowledgeCatalogQuery } from 'query/knowledge';
import useCan from 'hooks/useCan';
import { isPluginCatalog } from 'pages/KnowledgeSettings/helpers';

export const useCatalogPermission = (catalogId: string) => {
  const canWriteSection = useCan({
    edit: 'sections',
    for: 'settings_section.knowledgebase_setting',
  });

  const catalogQueryOptions = useMemo(
    () => knowledgeCatalogQuery(catalogId, { staleTime: 0, enabled: !!catalogId }),
    [catalogId]
  );

  const { data: catalog } = useQuery(catalogQueryOptions);

  const canWrite = canWriteSection && !isPluginCatalog(catalog);

  return { canWriteSection, canWrite };
};
